import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Button, Flex, Text } from 'core/components';
import KaizenList from './KaizenList';

@observer
class KaizenChatList extends Component {
  state = {
    showAll: false
  };

  handleToggleShowAll = () => {
    this.setState((prevState) => ({
      showAll: !prevState.showAll
    }));
  };

  render() {
    const {
      journeys = [],
      title,
      onSelectJourney,
      hideUserName = false,
      hideEditedDate = true,
      hideShareLevel = false,
      isCopilotMode = false,
      maxInitialItems = 10
    } = this.props;
    const { showAll } = this.state;

    // Already sorted journeys from ChatSessionCollection (pinned first, then by updated_at)
    const displayJourneys = showAll ? journeys : journeys.slice(0, maxInitialItems);
    const hasMoreItems = journeys.length > maxInitialItems;

    return (
      <Flex flexDirection="column" gap={1}>
        {title && <Text fontWeight="bold">{title}</Text>}

        <KaizenList
          isCopilotMode={isCopilotMode}
          onSelectJourney={onSelectJourney}
          hideUserName={hideUserName}
          hideShareLevel={hideShareLevel}
          hideEditedDate={hideEditedDate}
          journeys={displayJourneys}
        />

        {hasMoreItems && !showAll && (
          <Button
            minimal
            small
            text={`Show ${journeys.length - maxInitialItems} more`}
            onClick={this.handleToggleShowAll}
          />
        )}

        {showAll && hasMoreItems && <Button minimal small text="Show less" onClick={this.handleToggleShowAll} />}
      </Flex>
    );
  }
}

export default KaizenChatList;
